<div class="container h-100">
  <div #top></div>
  <div
    #acc="ngbAccordion"
    [closeOthers]="true"
    class="m_accordion mb-3"
    ngbAccordion
  >
    <div
      *ngIf="state?.vertrag?.text_teilnahmeerklaerung_selbsteinschreibung"
      ngbAccordionItem
    >
      <div ngbAccordionHeader>
        <ng-template>
          <button ngbAccordionButton>
            Teilnahmeerklärung <br class="d-md-none"/><small
          >(Klick zum anzeigen/verbergen)</small
          >
          </button>
        </ng-template>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div
              [innerHTML]="
                state.vertrag?.text_teilnahmeerklaerung_selbsteinschreibung
              "
            ></div>
            <a
              (click)="top.scrollIntoView({ behavior: 'smooth' })"
              href="javascript:void(0)"
            >nach oben</a
            >
            &nbsp;|&nbsp;
            <a (click)="acc.collapseAll()" href="javascript:void(0)"
            >schließen</a
            >
          </ng-template>
        </div>
      </div>
    </div>
    <div
      *ngIf="state?.vertrag?.text_bedingungen_selbsteinschreibung"
      ngbAccordionItem
    >
      <div ngbAccordionHeader>
        <ng-template>
          <button ngbAccordionButton>
            Patienteninformationen <br class="d-md-none"/><small
          >(Klick zum anzeigen/verbergen)</small
          >
          </button>
        </ng-template>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div
              [innerHTML]="state.vertrag?.text_bedingungen_selbsteinschreibung"
            ></div>
            <a
              (click)="top.scrollIntoView({ behavior: 'smooth' })"
              href="javascript:void(0)"
            >nach oben</a
            >
            &nbsp;|&nbsp;
            <a (click)="acc.collapseAll()" href="javascript:void(0)"
            >schließen</a
            >
          </ng-template>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        state?.vertrag?.text_teilnahmeerklaerung_datenschutz_selbsteinschreibung
      "
      ngbAccordionItem
    >
      <div ngbAccordionHeader>
        <ng-template>
          <button ngbAccordionButton>
            Datenschutzinformationen <br class="d-md-none"/><small
          >(Klick zum anzeigen/verbergen)</small
          >
          </button>
        </ng-template>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div
              [innerHTML]="
                state.vertrag
                  ?.text_teilnahmeerklaerung_datenschutz_selbsteinschreibung
              "
            ></div>
            <a
              (click)="top.scrollIntoView({ behavior: 'smooth' })"
              href="javascript:void(0)"
            >nach oben</a
            >
            &nbsp;|&nbsp;
            <a (click)="acc.collapseAll()" href="javascript:void(0)"
            >schließen</a
            >
          </ng-template>
        </div>
      </div>
    </div>
    <div
      *ngIf="state?.vertrag?.text_therapieinhalte_selbsteinschreibung"
      ngbAccordionItem
    >
      <div ngbAccordionHeader>
        <ng-template>
          <button ngbAccordionButton>
            Weitere Therapieinformationen <br class="d-md-none"/><small
          >(Klick zum anzeigen/verbergen)</small
          >
          </button>
        </ng-template>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div
              [innerHTML]="
                state.vertrag?.text_therapieinhalte_selbsteinschreibung
              "
            ></div>
            <a
              (click)="top.scrollIntoView({ behavior: 'smooth' })"
              href="javascript:void(0)"
            >nach oben</a
            >
            &nbsp;|&nbsp;
            <a (click)="acc.collapseAll()" href="javascript:void(0)"
            >schließen</a
            >
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="row row-cols-1 pt-4">
    <div class="col">
      <h5>Zusammenfassung Ihrer Daten</h5>
    </div>
  </div>
  <!-- mobile view -->
  <div class="row row-cols-1 d-md-none">
    <div class="col">
      <div class="row">
        <label>
          Untenstehend sehen Sie die Daten Ihres behandelnden Arztes
        </label>
      </div>
      <div *ngIf="state?.arzt?.praxis_name" class="form-group">
        <label class="small">Name des Institutes</label>
        <div>{{ state?.arzt?.praxis_name }}</div>
      </div>
      <div class="form-group">
        <label class="small">Behandelnder Arzt</label>
        <div>{{ state?.arzt?.anrede_titel_nachname }}</div>
      </div>
      <div class="form-group">
        <label class="small">Anschrift</label>
        <div>{{ state?.arzt?.adresse }}</div>
      </div>
    </div>
    <div class="col">
      <hr/>
      <div class="row">
        <label
        >Hier sehen Sie Ihre erfassten Daten.
          <b>Bitte prüfen Sie, ob diese korrekt sind</b></label
        >
      </div>
      <div class="form-group">
        <label class="small">Krankenkasse</label>
        <div>{{ state?.input_form.get("krankenkasse")?.value?.name }}</div>
        <div class="text-center">
          <img
            [src]="state?.input_form.get('krankenkasse')?.value?.logo"
            alt="Logo der Krankenkasse"
            height="48"
          />
        </div>
      </div>
      <ng-container
        *ngIf="state?.input_form.get('krankenkasse')?.value?.telefonnummer"
      >
        <div class="form-group">
          <label class="small">Rufnummer Ihrer Kasse</label>
          <div>
            {{ state?.input_form.get("krankenkasse")?.value?.telefonnummer }}
          </div>
        </div>
        <div
          *ngIf="state?.input_form.get('krankenkasse')?.value?.tel_nr_help_text"
          class="form-group"
        >
          <div>
            {{ state?.input_form.get("krankenkasse")?.value?.tel_nr_help_text }}
          </div>
        </div>
      </ng-container>
      <div class="form-group">
        <label class="small">Versichertennummer</label>
        <div>{{ state?.input_form.get("versicherten_nummer")?.value }}</div>
      </div>
      <div class="form-group">
        <label class="small">Geburtsdatum</label>
        <div>
          {{
            state?.input_form.get("geburtsdatum")?.value | date: "dd.MM.yyyy"
          }}
        </div>
      </div>
      <div class="form-group">
        <label class="small">Name</label>
        <div>
          {{ state?.input_form.get("nachname")?.value }},
          {{ state?.input_form.get("vorname")?.value }}
        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="text-center w-100">
          <input
            [@submitError]="
              submitChecking.includes(BED_UNCHECKED.bed1) ? 'pulsed' : 'base'
            "
            [formControl]="bed1"
            id="cbxm1"
            type="checkbox"
          />
        </div>
        <label class="form-check-label" for="cbxm1">
          <ng-container *ngIf="!bed1.valid && bed1.touched">
            <div class="form-input-error">Dieses Feld ist ein Pflichtfeld</div>
          </ng-container>
          Ja, ich habe die Erläuterungen zur Teilnahme und die
          Patienteninformation erhalten und möchte gemäß den dortigen
          Ausführungen das Angebot der Besonderen Versorgung nutzen und
          bestätige dies hiermit.
        </label>
      </div>
      <div class="row">
        <div class="text-center w-100">
          <input
            [@submitError]="
              submitChecking.includes(BED_UNCHECKED.bed2) ? 'pulsed' : 'base'
            "
            [formControl]="bed2"
            id="cbxm2"
            type="checkbox"
          />
        </div>
        <label for="cbxm2">
          <ng-container *ngIf="!bed2.valid && bed2.touched">
            <div class="form-input-error">Dieses Feld ist ein Pflichtfeld</div>
          </ng-container>
          Ja, ich habe die Erläuterungen zur Einwilligung in die
          Datenverarbeitung und -nutzung erhalten und bin mit der beschriebenen
          Datenerhebung, -verarbeitung und -nutzung im Rahmen meiner Teilnahme
          an der Besonderen Versorgung einverstanden und bestätige dies hiermit.
        </label>
      </div>
      <div class="row">
        <div class="text-center w-100">
          <input
            [(ngModel)]="zustimmungEvaluation"
            [disabled]="sending"
            id="cbxm3"
            type="checkbox"
          />
        </div>
        <label for="cbxm3">
          <b>OPTIONAL (keine Pflicht):</b> Ich willige ein, dass meine Daten zu Forschungszwecken anonymisiert
          werden können und meine anonymisierten Daten, die mir nicht mehr zugeordnet werden können,
          auch nach dem Widerruf der Einwilligung verarbeitet werden können.
        </label>
      </div>
      <hr/>
    </div>
  </div>
  <!-- desktop view -->
  <div class="row row-cols-1 d-none d-md-block">
    <div class="col">
      <table class="table table-borderless data-table table-sm">
        <tr>
          <td colspan="2">
            Untenstehend sehen Sie die Daten Ihres behandelnden Arztes
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <hr class="my-0"/>
          </td>
          <td colspan="2">
            <hr class="my-0"/>
          </td>
        </tr>
        <tr *ngIf="state?.arzt?.praxis_name">
          <td>Name des Institutes</td>
          <td>{{ state?.arzt?.praxis_name }}</td>
        </tr>
        <tr>
          <td>Behandelnder Arzt</td>
          <td>{{ state?.arzt?.anrede_titel_nachname }}</td>
        </tr>
        <tr>
          <td>Anschrift</td>
          <td>{{ state?.arzt?.adresse }}</td>
        </tr>
        <tr>
          <!--          <td>Anschrift</td>-->
          <!--          <td>{{state?.patient.strasse}} {{state?.patient.hausnummer}}-->
          <!--            , {{state?.patient.plz}} {{state?.patient.ort}}</td>-->
        </tr>
        <tr>
          <td colspan="2">
            <hr class="my-0"/>
          </td>
          <td colspan="2">
            <hr class="my-0"/>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Hier sehen Sie Ihre erfassten Daten.
            <b>Bitte prüfen Sie, ob diese korrekt sind</b>
          </td>
        </tr>
        <tr>
          <td>Krankenkasse</td>
          <td>{{ state?.input_form.get("krankenkasse")?.value?.name }}</td>
          <div class="text-center">
            <img
              [src]="state?.input_form.get('krankenkasse')?.value?.logo"
              alt="Logo der Krankenkasse"
              height="48"
            />
          </div>
        </tr>
        <ng-container
          *ngIf="state?.input_form.get('krankenkasse')?.value?.telefonnummer"
        >
          <tr>
            <td>Rufnummer Ihrer Kasse:</td>
            <td>
              {{ state?.input_form.get("krankenkasse")?.value?.telefonnummer }}
            </td>
          </tr>
          <tr
            *ngIf="
              state?.input_form.get('krankenkasse')?.value?.tel_nr_help_text
            "
          >
            <td class="fs-6" colspan="4">
              {{
                state?.input_form.get("krankenkasse")?.value?.tel_nr_help_text
              }}
            </td>
          </tr>
        </ng-container>
        <tr>
          <td>Versichertennummer</td>
          <td>{{ state?.input_form.get("versicherten_nummer")?.value }}</td>
        </tr>
        <tr>
          <td>Name</td>
          <td>
            {{ state?.input_form.get("nachname")?.value }},
            {{ state?.input_form.get("vorname")?.value }}
          </td>
        </tr>
        <tr>
          <td>Geburtstag</td>
          <td>
            {{
              state?.input_form.get("geburtsdatum")?.value | date: "dd.MM.yyyy"
            }}
          </td>
        </tr>
      </table>
      <div class="row">
        <table class="table table-borderless">
          <tr>
            <td class="p-2">
              <input
                [@submitError]="
                  submitChecking.includes(BED_UNCHECKED.bed1)
                    ? 'pulsed'
                    : 'base'
                "
                [formControl]="bed1"
                id="cbx1"
                type="checkbox"
              />
            </td>
            <td>
              <label for="cbx1">
                <ng-container *ngIf="!bed1.valid && bed1.touched">
                  <div class="form-input-error">
                    Dieses Feld ist ein Pflichtfeld
                  </div>
                </ng-container>
                Ja, ich habe die Erläuterungen zur Teilnahme und die
                Patienteninformation erhalten und möchte gemäß den dortigen
                Ausführungen das Angebot der Besonderen Versorgung nutzen und
                bestätige dies hiermit.
              </label>
            </td>
          </tr>
          <tr>
            <td class="p-2">
              <input
                [@submitError]="
                  submitChecking.includes(BED_UNCHECKED.bed2)
                    ? 'pulsed'
                    : 'base'
                "
                [formControl]="bed2"
                id="cbx2"
                type="checkbox"
              />
            </td>
            <td>
              <label for="cbx2">
                <ng-container *ngIf="!bed2.valid && bed2.touched">
                  <div class="form-input-error">
                    Dieses Feld ist ein Pflichtfeld
                  </div>
                </ng-container>
                Ja, ich habe die Erläuterungen zur Einwilligung in die
                Datenverarbeitung und -nutzung erhalten und bin mit der
                beschriebenen Datenerhebung, -verarbeitung und -nutzung im
                Rahmen meiner Teilnahme an der Besonderen Versorgung
                einverstanden und bestätige dies hiermit.
              </label>
            </td>
          </tr>
          <tr>
            <td class="p-2">
              <input
                [(ngModel)]="zustimmungEvaluation"
                [disabled]="sending"
                id="cbx3"
                type="checkbox"
              />
            </td>
            <td>
              <label for="cbx3">
                <b>OPTIONAL (keine Pflicht):</b> Ich willige ein, dass meine Daten zu Forschungszwecken anonymisiert
                werden können und meine anonymisierten Daten, die mir nicht mehr zugeordnet werden können,
                auch nach dem Widerruf der Einwilligung verarbeitet werden können.
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!-- both -->
  <div class="row mt-1">
    <div class="col text-center">
      <button
        (click)="zurueck.emit()"
        [disabled]="sending"
        class="btn btn-primary m-lg-5"
      >
        Zurück
      </button>
    </div>
    <div class="col text-center">
      <button
        #btnBestaetigen
        (click)="onBestaetigenClicked()"
        [disabled]="sending"
        class="btn btn-primary m-lg-5"
      >
        Bestätigen<span *ngIf="sending"
      >&nbsp;<fa-icon [icon]="spinnerIcon" animation="spin-pulse"></fa-icon
      ></span>
      </button>
    </div>
  </div>
</div>
